import { render, staticRenderFns } from "./PriceRuleEditFilterItem.vue?vue&type=template&id=08edac22&scoped=true"
import script from "./PriceRuleEditFilterItem.vue?vue&type=script&lang=ts"
export * from "./PriceRuleEditFilterItem.vue?vue&type=script&lang=ts"
import style0 from "./PriceRuleEditFilterItem.vue?vue&type=style&index=0&id=08edac22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08edac22",
  null
  
)

export default component.exports